// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// import {} from '../package.json';

export const environment = {
  production: false,
  // version: '1.14.0',
  version: require('../../package.json').version,
  AGM_API_KEY: 'AIzaSyDiFMbTxMTyO9s9wijQ9fq28yCQTd3Hckg',
};





/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
